import AppTextInput from './AppTextInput';

export default AppTextInput